/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForCostRecommendation extends models.GovernanceConfigurationBaseForCost {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForCostRecommendation.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForCostRecommendation>): GovernanceConfigurationBaseForCostRecommendation {
        let obj = Object.assign(new GovernanceConfigurationBaseForCostRecommendation(), model);
        GovernanceConfigurationBaseForCostRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForCostRecommendation>): GovernanceConfigurationBaseForCostRecommendation {
        if (!model) return null;
        return GovernanceConfigurationBaseForCostRecommendation.newInstance(<GovernanceConfigurationBaseForCostRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForCostRecommendation) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForCostRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForCostRecommendation): boolean {
        if (models.GovernanceConfigurationBaseForCost.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForCostRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
